// Copyright (c) 2020 Deere & Company

import LaborRateRequestCount, {getDefaultState as getLaborRatesDefaultState} from '@deere/cps-it.warranty-model-factory/lib/labor-rate-request-count';
import actions from '../actions-list';

const updateLaborRateRequestCount = (state, action) =>
LaborRateRequestCount.update(state, {
    $set: action.data
});

export default (state = getLaborRatesDefaultState(), action) => {

    const actionTypes = {
        [actions.SET_LABOR_RATE_COUNT]: updateLaborRateRequestCount
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/reducers/labor-rate-request-count.js